import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=4933ecb5&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"
import style0 from "./customer.vue?vue&type=style&index=0&id=4933ecb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4933ecb5",
  null
  
)

export default component.exports